/** @format */

import {useEffect, useState} from 'react';
import contentData from '../../../data/contentData';
import {PackageCard} from './PackageCard';
import {MarketingPackageAccordionProps, PricingProps} from './PackageCardElements';

export type DynamicPricing = {
	pricing: PricingProps;
	accordion?: MarketingPackageAccordionProps['pricing'];
};

const OwnerAndManagerPackageCard = ({dynamicPricing = null}: {
	dynamicPricing?: DynamicPricing;
}) => {
	let {pricing, marketingPackageAccordion} = contentData.packages[0].cmsContent;
	const {topCard, bullets, memberPackage}
		= contentData.packages[0].cmsContent;

	if (dynamicPricing) {
		pricing = dynamicPricing.pricing;
		marketingPackageAccordion.pricing = dynamicPricing.accordion;
	}

	return (
		<PackageCard
			topCard={topCard}
			bullets={{bullets}}
			pricing={pricing}
			marketingPackageAccordion={marketingPackageAccordion}
			memberPackage={memberPackage}
		/>
	);
};

const AgenciesPackageCard = ({dynamicPricing = null}: {
	dynamicPricing?: DynamicPricing;
}) => {
	let {pricing, marketingPackageAccordion} = contentData.packages[1].cmsContent;
	const {topCard, bullets, memberPackage}
		= contentData.packages[1].cmsContent;

	if (dynamicPricing) {
		pricing = dynamicPricing.pricing;
		marketingPackageAccordion.pricing = dynamicPricing.accordion;
	}

	return (
		<PackageCard
			topCard={topCard}
			bullets={{bullets}}
			pricing={pricing}
			marketingPackageAccordion={marketingPackageAccordion}
			memberPackage={memberPackage}
		/>
	);
};

const TradeSupplierPackageCard = ({dynamicPricing = null}: {
	dynamicPricing?: DynamicPricing;
}) => {
	let {pricing, marketingPackageAccordion} = contentData.packages[2].cmsContent;
	const {topCard, bullets, memberPackage}
		= contentData.packages[2].cmsContent;

	if (dynamicPricing) {
		pricing = dynamicPricing.pricing;
	}

	return (
		<PackageCard
			topCard={topCard}
			bullets={{bullets}}
			pricing={pricing}
			marketingPackageAccordion={marketingPackageAccordion}
			memberPackage={memberPackage}
		/>
	);
};

const PartnersCard = () => {
	const {topCard, textSections, cta, memberPackage}
		= contentData.packages[3].cmsContent;

	return (
		<PackageCard
			topCard={topCard}
			textSections={textSections}
			cta={cta}
			memberPackage={memberPackage}
		/>
	);
};

export type ProductCardPrices = {
	asscMembership: DynamicPricing;
	agencyMembership: DynamicPricing;
	tradeSupplierMembership: DynamicPricing;
};

export const PackageCards = () => {
	const [productPrices, setProductPrices] = useState<ProductCardPrices>();

	useEffect(() => {
		const fetchProductPrices = async () => {
			const res = await fetch('/api/stripe/getProductCardPrices');
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			const data = await res.json();
			setProductPrices(data.prices);
		};

		void fetchProductPrices();
	}, []);

	if (productPrices) {
		return (
			<>
				<OwnerAndManagerPackageCard dynamicPricing={productPrices.asscMembership} />
				<AgenciesPackageCard dynamicPricing={productPrices.agencyMembership} />
				<TradeSupplierPackageCard dynamicPricing={productPrices.tradeSupplierMembership} />
				<PartnersCard />
			</>
		);
	}

	return (
		<>
			<OwnerAndManagerPackageCard />
			<AgenciesPackageCard />
			<TradeSupplierPackageCard />
			<PartnersCard />
		</>
	);
};

export default PackageCards;
